import React from 'react';
import PayverseProcess from 'app/components/OrderPayment/Payverse/PayverseProcess';

const PayversePayment = () => {
  return <PayverseProcess />;
};

export default PayversePayment;
